import { DxContainer, DxGrid, DxSpacer } from '@dvag/design-system-react';
import type { FC } from 'react';

import { KundenstammdatenWebComponent } from 'component/KundenstammdatenWebComponent/KundenstammdatenWebComponent';

export const PersonalDataForm: FC = () => (
  <DxContainer color="transparent" data-testid="personal-data-form">
    <DxGrid mq1="12/*">
      <DxContainer type="page" color="transparent">
        <DxSpacer size="16v" />
        <KundenstammdatenWebComponent />
        <DxSpacer size="16v" />
      </DxContainer>
    </DxGrid>
  </DxContainer>
);
